const routes = [
    {
        type: 'route',
        path: '/',
        routes: [
            {
                type: 'application',
                name: '@pulselive/cms-ui'
            }
        ]
    },
    {
        type: 'route',
        path: '/page-builder',
        routes: [
            {
                type: 'application',
                name: '@pulselive/visual-editor'
            }
        ]
    },
    {
        type: 'route',
        path: '/visual-editor',
        routes: [
            {
                type: 'application',
                name: '@pulselive/visual-editor'
            }
        ]
    },
    {
        type: 'route',
        path: '/rugby',
        featureFlag: 'exp-use-rugby-microfrontend',
        routes: [
            {
                type: 'application',
                name: '@pulselive/cms-ui-rugby'
            }
        ]
    },
    {
        type: 'route',
        path: '/content-2-alpha', // Note: temporary route, will become it's own app
        featureFlag: 'content-frontend',
        routes: [
            {
                type: 'application',
                name: '@pulselive/content-2-frontend'
            }
        ]
    }
];

import contentRoutes from './content.routes';
import blogRoutes from './blog.routes';
import siteRoutes from './site.routes';
import footballRoutes from './football.routes';
import cricketRoutes from './cricket.routes';
import aflFootballRoutes from './aflFootball.routes';
import atpTennisRoutes from './atpTennis.routes';
import fantasyRoutes from './fantasy.routes';
import rugbyRoutes from './rugby.routes';
import productRoutes from './product.routes';
import adminRoutes from './admin.routes';

export const navItemsData = [
    {
        text: 'Dashboard',
        path: '/',
        icon: 'home.svg',
        children: [],
        permissions: true
    },
    contentRoutes,
    blogRoutes,
    siteRoutes,
    footballRoutes,
    cricketRoutes,
    aflFootballRoutes,
    atpTennisRoutes,
    fantasyRoutes,
    rugbyRoutes,
    productRoutes,
    adminRoutes
];

export default routes;
